import {Component, OnInit, ViewChild} from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from "@angular/router";
import { UserService } from 'src/app/services/user.service';
import {BreakpointObserver} from "@angular/cdk/layout";
import {map, Observable, shareReplay} from "rxjs";
import {MatSidenav} from "@angular/material/sidenav";
import {faCircleQuestion} from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'app-header-menu',
    templateUrl: './header-menu.component.html',
    styleUrls: ['./header-menu.component.scss'],
    standalone: false
})
export class HeaderMenuComponent implements OnInit {
  expanded: boolean = false;
  user: any;
  isLoggedIn: boolean = false;
  sideNavOpen = false;

  isHandset$!: Observable<boolean>;
  @ViewChild('drawer') drawer?: MatSidenav;
  protected readonly faCircleQuestion = faCircleQuestion;

  constructor(
    private readonly authService: AuthService,
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly bp: BreakpointObserver,
  ) { }

  ngOnInit(): void {
    this.userService.getUserProfile().then((user) => this.user = user);
    this.isLoggedIn = true;
    this.isHandset$ = this.bp
      .observe([`(max-width: 1024px)`])
      .pipe(map(r => r.matches), shareReplay({bufferSize: 1, refCount: true}));
  }

  toggle() {
    this.expanded = !this.expanded;
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['login']);
  }

  openMenu() {
    this.sideNavOpen = true;
  }
  onDrawerClosed() {
    this.sideNavOpen = false;
  }
}
